import PropTypes from 'prop-types';

import { FeedbackWidgetLayout } from 'components';
import * as SharedZoneProductGoods from 'store/SharedZone/blocks/goods/selectors';

const mapStateToProps = (state) => ({
  rateFill: SharedZoneProductGoods.getRate(state),
  rateCount: SharedZoneProductGoods.getFeedbackCount(state),
  feedbackUrl: SharedZoneProductGoods.getOtzyvyUrl(state),
  hasFeedback: !!SharedZoneProductGoods.getRate(state),
});

const FeedbackWidget = SharedZoneProductGoods.connect(mapStateToProps)(FeedbackWidgetLayout);

FeedbackWidget.propTypes = {
  isCompact: PropTypes.bool,
  id: PropTypes.number.isRequired,
};

export default FeedbackWidget;
